import { render, staticRenderFns } from "./FloatingMenu.vue?vue&type=template&id=4d6d4ad8&scoped=true"
import script from "./FloatingMenu.vue?vue&type=script&lang=js"
export * from "./FloatingMenu.vue?vue&type=script&lang=js"
import style0 from "./FloatingMenu.vue?vue&type=style&index=0&id=4d6d4ad8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6d4ad8",
  null
  
)

export default component.exports